<section class="subpage_banner">
  <div class="img_area">
    <img src="../assets/images/subpage_banner.jpg" alt="" />
  </div>
  <div class="text_area">

  </div>
</section>

<section class="body_section">
  <div class="container">

    <div class="payment_protection_section">
      @if (messageType != 'Payment failed') {
        <div class="inner">
          <img src="../assets/images/payment_success.svg" alt="" class="payment_success" />
        </div>
      }
      @if (messageType == 'Payment failed') {
        <div class="inner">
          <img src="../assets/images/failed.svg" alt="" class="payment_success" />
        </div>
      }
      <p class="mt-3"><strong>Go to your app</strong></p>
    </div>

  </div>
</section>